module.exports = {
      id: "mode-select-usage",
      viewBox: "0 0 21 24",
      url: __webpack_public_path__ + "img/icons.a7e6c507.svg#mode-select-usage",
      toString: function () {
        return this.url;
      }
    }